<template>
  <div>
    <div class="products-banner contact-jumbo">
      <div class="container">
        <div class="row">
          <div class="col-lg-6">
            <h1 class="white">
             Contact Me
            </h1>
            <p class="white no-bottom">Use the contact info below or the contact form to reach out to me.</p>
          </div>
        </div>
      </div>
    </div>
    <div class="container section-padding section-pad-no-bottom padding-iphone">
      <div class="row">
        <!-- <div class="col-lg-4 col-md-4 center border-right">
          <PhoneIcon class="size-icon" />
          <h3 class="sizing-ipad">613-932-1234</h3>
        </div> -->
        <div class="col-lg-6  col-md-6 center">
          <EmailIcon class="size-icon" />
          <h3 class="sizing-ipad">frankshangar@gmail.com</h3>
        </div>
        <div class="col-lg-6  col-md-6 border-left center">
          <ClockIcon class="size-icon" />
          <h3 class="sizing-ipad">9-5 Mon-Fri</h3>
        </div>
      </div>
    </div>
    <div class="container section-padding" v-if="processing">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div class="container section-padding" v-else>
      <form v-if="!submitted" @submit.prevent="processForm">
        <div class="form-group">
          <label for="name">Name:</label>
          <input v-model="form.name" type="text" class="form-control" id="name" placeholder="Name" />
        </div>
        <div class="form-group">
          <label for="email">Email:</label>
          <input v-model="form.email" type="email" class="form-control" id="email" placeholder="Email" />
        </div>
        <div class="form-group">
          <label for="phone">Phone:</label>
          <input v-model="form.phone" type="tel" class="form-control" id="phone" placeholder="Phone" />
        </div>
        <div class="form-group">
          <label for="message">Message:</label>
          <textarea class="form-control" id="message" v-model="form.message" rows="3"></textarea>
        </div>
        <vue-recaptcha v-on:verify="recaptchaVerify" sitekey="6LeW37cZAAAAAJSvx3XOsh7DmkWIjRRUVVkE4Yng"></vue-recaptcha>
        <div v-if="errorMessage != ''" style="color: red">{{errorMessage}}</div>
        <button type="submit" class="btn space-top-small">Send</button>
      </form>
      <div v-else>
        <h4>Contact information submitted. Frank will be in touch shortly!</h4>
      </div>
    </div>
  </div>
</template>

<script>
  import api from "../api/api";
  import VueRecaptcha from "vue-recaptcha";
  //import PhoneIcon from 'vue-material-design-icons/Phone.vue';
  import EmailIcon from 'vue-material-design-icons/Email.vue';
  import ClockIcon from 'vue-material-design-icons/Clock.vue';
  export default {
    components: {
      VueRecaptcha,
      //PhoneIcon,
      EmailIcon,
      ClockIcon
    },
    data: function () {
      return {
        form: {
          name: "",
          phone: "",
          email: "",
          message: "",
          recaptcha: "",
        },
        processing: false,
        submitted: false,
        errorMessage: "",
      };
    },
    methods: {
      recaptchaVerify(args) {
        this.form.recaptcha = args;
      },
      validateForm() {
        let error = "";
        this.errorMessage = "";
        if (this.form.name == "") {
          error = error + "Must enter a name\n";
        }
        if (!(this.form.email != "" || this.form.phone != "")) {
          error = error + "Must enter either a phone number or an email\n";
        }
        if (this.form.message == "") {
          error = error + "Must enter a message\n";
        }
        if (this.form.recaptcha == "") {
          error = error + "Must click recaptcha\n";
        }
        if (error != "") {
          this.errorMessage = error;
          return false;
        }
        return true;
      },
      processForm() {
        if (!this.validateForm()) {
          return;
        }
        this.processing = true;
        api
          .sendContactRequest(
            this.form.name,
            this.form.message,
            this.form.phone,
            this.form.email,
            this.form.recaptcha
          )
          // .then((res) => {
          //   console.log(res);
          // })
          // .catch((err) => {
          //   console.log(err);
          // })
          .finally(() => {
            this.submitted = true;
            this.processing = false;
          });
      },
    },
  };
</script>